document.addEventListener('DOMContentLoaded', function () {

    setTimeout(function () {
      const swiperEl = document.querySelector('.swiper-article');

      if (swiperEl) {
        new Swiper(swiperEl, {
          slidesPerView: 1.2,
          spaceBetween: 15,
          centeredSlides: false,
          loop: false,
          // scrollbar: {
          //   el: '.swiper-scrollbar',
          //   draggable: true, 
          // },
          breakpoints: {
            480: {
              slidesPerView: 1.5,
              spaceBetween: 15,
            },
            640: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
          },
        });
      }
    }, 1000);

});